// Regular expressions

export const ALPHA_NUMERIC_REGEX = /[^a-zA-Z0-9 _-]/g
export const STAR_FOLLOWED_BY_TLD_REGEX = /^(?:\*\.[a-zA-Z]{2,64})$/
export const GET_SERVICE_NAME_FROM_URL_REGEX = /%23([^%23]+)%23/ // %23 is the URL encoded value for #

// Functions

/**
 * Remove all characters except alphanumeric, spaces, underscores, and hyphens
 * @param str
 * @returns {string}
 */
export const cleanAlphaNumeric = (str: string) =>
  str.replace(ALPHA_NUMERIC_REGEX, '')

/**
 * @description
 * function to specifically test wildcard followed by a TLD
 * @params
 * url - url string to test.
 * @returns
 * boolean - true if the URL contains a * wildcard followed by a TLD, false otherwise.
 */
export const checkWildcardWithTLD = (url: string): boolean => {
  const wildCardWithTLD = new RegExp(STAR_FOLLOWED_BY_TLD_REGEX)
  return wildCardWithTLD.test(url)
}
